module.exports = __webpack_public_path__ + "static/media/32_A.037ab1d4.png";